import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { requests } from '.'

// Configure request setup
const serviceName = 'AiWrapperService'
const host = servicesConfig.AiWrapper
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const AIWrapperService = {
  fetchAICompanyPlan: async (companyId: string): Promise<any> => {
    try {
      const url = `/plan/company?companyId=${companyId}`
      const res = await request().get(url).then(responseBody)
      if (res) {
        // check if it's set to disabled or not
        return res
      }
    } catch (err) {
      console.log(err)
      return null
    }
  },

  fetchFeatureFlags: async (companyId: string): Promise<any> => {
    try {
      console.log('fetchFeatureFlags', companyId)
      const url = `/plan/feature-flags?companyId=${companyId}`
      const res = await request().get(url).then(responseBody)
      console.log('fetchFeatureFlags', res)
      res.LastSyncedAt = new Date().toISOString()
      return res
    } catch (err) {
      console.log(err)
      return null
    }
  },

  isSummerOfAIOptinForLocation: async (locationId: string, routePathParams: any): Promise<any> => {
    try {
      const url = `/plan/location?locationId=${locationId}`
      const res = await request()
        .get(url, {
          headers: routePathParams,
        })
        .then(responseBody)
      if (res) {
        return res
      }
      return null
    } catch (err) {
      console.log(err)
      return null
    }
  },

  isAIEmployeeSubscribed: async (companyId: string): Promise<any> => {
    try {
      const url = `plan/company/ai-employee-subscriptions?companyId=${companyId}`
      const res = await request().get(url).then(responseBody)
      if (res) {
        return res
      }
      return null
    } catch (err) {
      console.log(err)
      return null
    }
  },
}

export default AIWrapperService
